import {
  EVENT_CONSTANTS,
  getLayoutByIdApi,
  LayoutResponseType,
  WorkflowProcessType,
} from '@app-store'
import React, { useEffect, useState } from 'react'
import {
  getEntityData,
  getEntityDataByIdEmbedded,
} from '../../apis/entityData.api'
import { FieldValues } from 'react-hook-form'
import { EntityLayout, LayoutData } from '../../types/layout.types'
import { noop } from 'lodash'
import FormRenderer from '../FormRenderer'

const StickySummary = ({
  recordId,
  workflowDefinition,
}: {
  recordId: string
  workflowDefinition: WorkflowProcessType
}) => {
  const entityId =
    workflowDefinition?.global_variables?.sticky_summary?.entity_id
  const layoutId =
    workflowDefinition?.global_variables?.sticky_summary?.layout_id
  const [layout, setLayout] = useState<LayoutResponseType>()
  const [layoutData, setLayoutData] = useState<FieldValues>()

  const fetchLayout = async () => {
    try {
      const response = await getLayoutByIdApi({
        entityId: entityId,
        layoutId: layoutId,
      })
      if (response.data) {
        setLayout(response?.data)
        await fetchEntityData()
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchEntityData = async () => {
    try {
      const caseSummaryId = await getEntityDataByIdEmbedded(
        workflowDefinition?.global_variables?.entity_name ?? '',
        Number(workflowDefinition?.global_variables?.entity_id),
        ['case_summary'], // to improve
        recordId
      )
      if (caseSummaryId?.data?.['case_summary']) {
        const response = await getEntityData(
          'case_summary',
          Number(entityId),
          Number(layoutId),
          caseSummaryId?.data?.case_summary?.id
        )
        if (response.data) {
          setLayoutData(response?.data)
        }
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchLayout()
  }, [entityId, layoutId])

  useEffect(() => {
    window.addEventListener(
      EVENT_CONSTANTS?.TASK_COMPLETE_REFETCH_SUMMARY,
      fetchEntityData
    )
    return () => {
      window.removeEventListener(
        EVENT_CONSTANTS?.TASK_COMPLETE_REFETCH_SUMMARY,
        fetchEntityData
      )
    }
  }, [])

  return (
    <div className="w-full pt-3">
      <FormRenderer
        heading={undefined}
        layout={layout?.layout_data as LayoutData}
        mode={'view'}
        handleFormSubmit={noop}
        data={layoutData}
        fullLayout={layout as EntityLayout}
        isStickySummary={true}
      />
    </div>
  )
}

export default StickySummary
